<template>
  <div
    id="LmCommentBox"
    class="LmCommentBox p-5 -mx-5 desktop:p-6 desktop:-mx-6"
  >
    <user-info :id="userData._id" size="32px" />
    <lm-editor
      ref="LmEditor"
      v-model="text"
      class="mt-4 desktop:ml-12"
      type="comment"
      label="Add your comment"
      :modal="false"
      @submit="sendComment"
    />
    <lm-modal-button
      :disabled="text === ''"
      class="mt-2 ml-auto"
      type="primary"
      title="Send comment"
      @click="sendComment"
    />
  </div>
</template>

<script>
import LmModalButton from '@/components/ui/button/LmModalButton'
import {Events} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import {mapGetters} from 'vuex'
import VueScrollTo from 'vue-scrollto'
import UserInfo from '@/components/landscape/topics/UserInfo'
import LmEditor from '@/components/form/LmEditor'
import FormHelper from '@/components/form/formHelper'

export default {
  name: 'LmCommentBox',
  components: {
    LmModalButton,
    UserInfo,
    LmEditor
  },
  props: {
    section: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activity: 'Now',
      text: ''
    }
  },
  computed: mapGetters(['userData', 'getUserByID']),
  watch: {
    $route(to, from) {
      if (to.params.premiseSlug !== from.params.premiseSlug) {
        this.text = ''
      }
    }
  },
  mounted() {
    EventHub.on(Events.REPLY_COMMENT, this.replyTo)
  },
  destroyed() {
    EventHub.removeListener(Events.REPLY_COMMENT, this.replyTo)
  },
  methods: {
    sendComment() {
      if (this.text === '') return
      // TODO Change topic logic !?
      const method =
        this.section === 'topics'
          ? 'createComment'
          : `${this.section}/createComment`
      this.$store
        .dispatch(method, {
          text: this.text,
          mentions: FormHelper.getEditorMentions()
        })
        .then(() => {
          this.text = ''
          this.$emit('comment-added')
          this.$store.dispatch('unsetDirty')
        })
        .catch(error => {
          console.log(' => ', error)
        })
    },
    replyTo(userId) {
      // Add class 'CommentBoxContainer' to the parent with the scroll
      const options = {container: '.CommentBoxContainer'}
      if (this.isMobile) options.container = 'body'
      VueScrollTo.scrollTo('.LmCommentBox', 500, options)
      const to = this.getUserByID(userId)
      this.$refs.LmEditor.addMention(to)
    }
  }
}
</script>
